import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const partialPay: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'ppId' },
            { type: 'field', field: 'ppInstallAmt' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'ppInstallDate' },
            { type: 'field', field: 'ppInstallType' },
        ],
    },
];

export default partialPay;
